// extracted by mini-css-extract-plugin
module.exports = {"Maximize":"Maximize-module__Maximize___24MQ4"};